import Route from '@ember/routing/route';
import { service } from '@ember/service';

export default class LocationOverviewAnalyticsProtectIndexRoute extends Route {
  title = 'Protect · Global Analytics · Envoy';

  @service abilities;
  @service featureFlags;
  @service router;

  redirect() {
    if (this.abilities.cannot('visit protect in global-analytics')) {
      if (this.abilities.can('visit analytics upsell in global-analytics')) {
        return this.router.transitionTo('location-overview.analytics.protect.upsell');
      } else {
        return this.router.transitionTo('unauthorized');
      }
    }
  }
}
